(function () {
    angular.module('tradersyard').component('tyEventsSlider', {
        // language=HTML
        template: `
            <!-- Swiper -->
            <div class="swiper-container {{ $ctrl.randomClassName }}" ng-if="$ctrl.countItems > 0">
                <div class="swiper-wrapper">
                    <div class="swiper-slide webinar-swipe-items" ng-repeat="(index, webinar) in $ctrl.webinars">
                        <ty-webinar-widget
                            is-authorized="$ctrl.isAuthorized"
                            webinar="webinar"
                        ></ty-webinar-widget>
                    </div>
                </div>
                <!-- Add Arrows -->
                <div class="swiper-button-next swiper-button-white"></div>
                <div class="swiper-button-prev swiper-button-white"></div>
            </div>
            <div class="swiper-container gallery-thumbs {{ $ctrl.randomGalleryClassName }}">
                <div class="swiper-wrapper">
                    <div class="swiper-slide" ng-repeat="(index, webinar) in $ctrl.webinars">
                        <img height="20" width="100%"  ng-src="{{webinar.picture.source|thumb:200:100}}" alt="{{webinar.name}}"/>
                    </div>
                </div>
            </div>
        `,
        bindings: {
            items: '<',
            isAuthorized: '<',
        },
        transclude: true,
        controller: EventsSliderCtrl,
    });

    EventsSliderCtrl.$inject = ['$scope', '$timeout'];

    function EventsSliderCtrl($scope, $timeout) {
        const ctrl = this;

        ctrl.slideIndex = 0;
        ctrl.countItems = 0;
        ctrl.webinars = [];

        ctrl.randomClassName = 'slider-' + moment().format('x') + Math.floor(Math.random() * 100);
        ctrl.randomGalleryClassName = 'gallery-' + moment().format('x') + Math.floor(Math.random() * 100);

        ctrl.showSlides = function () {
            var galleryThumbs = new Swiper(`.${ctrl.randomGalleryClassName}`, {
                spaceBetween: 2,
                slidesPerView: 4,
                loopedSlides: ctrl.webinars.length, //looped slides should be the same
                watchSlidesVisibility: true,
                watchSlidesProgress: true,
            });

            var swiper = new Swiper('.' + ctrl.randomClassName, {
                effect: 'cube',
                grabCursor: true,
                cubeEffect: {
                    shadow: true,
                    slideShadows: true,
                    shadowOffset: 20,
                    shadowScale: 0.94,
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                thumbs: {
                    swiper: galleryThumbs,
                },
            });

            $('.open-full-size-icon').click(function () {
                swiper.update();
            });
            $('.close-full-size-icon').click(function () {
                swiper.update();
            });
        };

        ctrl.$onInit = function () {
            if (typeof ctrl.items === 'boolean' && ctrl.items == false) {
                return;
            }

            ctrl.webinars = ctrl.items;
            ctrl.countItems = ctrl.webinars.length;

            $timeout(function () {
                ctrl.showSlides();
            });
        };
    }
})();
